(function (root) {
  const modes = ['straight', 'half-drop', 'half-brick', 'mirror', 'placement'];
  function dimensions(pixelWidth, pixelHeight, widthCm) {
    if (![pixelWidth, pixelHeight, widthCm].every(x => Number.isFinite(x) && x > 0)) return null;
    return { width: widthCm, height: widthCm * pixelHeight / pixelWidth, dpi: pixelWidth * 2.54 / widthCm };
  }
  function tiles(width, height, mode, windowCm = 50) {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width < 0.5 || height < 0.5 || width > 200 || height > 200 || !modes.includes(mode)) return [];
    if (mode === 'placement') return [{ x: (windowCm - width) / 2, y: (windowCm - height) / 2, flipX: false, flipY: false }];
    const result = [];
    for (let col = -1; col <= Math.ceil(windowCm / width); col++) {
      for (let row = -1; row <= Math.ceil(windowCm / height); row++) {
        const x = col * width + (mode === 'half-brick' && Math.abs(row % 2) ? width / 2 : 0);
        const y = row * height + (mode === 'half-drop' && Math.abs(col % 2) ? height / 2 : 0);
        if (x < windowCm && y < windowCm && x + width > 0 && y + height > 0) result.push({ x, y, flipX: mode === 'mirror' && Math.abs(col % 2) === 1, flipY: mode === 'mirror' && Math.abs(row % 2) === 1 });
      }
    }
    return result;
  }
  const api = { dimensions, tiles, modes };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.NiaashPrintMath = api;
})(typeof window === 'undefined' ? this : window);
